import { MantineColorsTuple, MantineProvider, createTheme } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import ReactGa from "react-ga4";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import "./index.scss";
import "@mantine/charts/styles.css";

import { routes } from "./routes.tsx";
import i18n from "./utilities/language";
import { watchSessionResume } from "./services/session";

watchSessionResume();

process.env.NODE_ENV === "production" &&
  Sentry.init({
    dsn: "https://a4ef4a299c441868be04386f2c02053e@sentry.hamravesh.com/7512",
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const myColor: MantineColorsTuple = [
  '#eff2ff',
  '#dfe2f2',
  '#bdc2de',
  '#99a0ca',
  '#7a84b9',
  '#6672af',
  '#5c69ac',
  '#4c5897',
  '#424e88',
  '#36437a'
];


const theme = createTheme({
  fontFamily: "YekanBakhNoEn",
  defaultRadius: "md",
  primaryColor: 'myColor',
  colors: {
    myColor,
    // Add your custom color to the existing Mantine color palette
    "light-gray": [
      "#f9f9f9", // Your color as the base shade
      "#f0f0f0",
      "#e6e6e6",
      "#d9d9d9",
      "#c9c9c9",
      "#b5b5b5",
      "#9d9d9d",
      "#828282",
      "#696969",
      "#525252",
    ],
  },
});

const TRAKING_ID = "G-FLNGCTF261";
ReactGa.initialize(TRAKING_ID);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <MantineProvider theme={theme}>
          {/* <Container px="0" bg="white"> */}
          <Notifications position="top-center" />
          <RouterProvider router={routes} />
          {/* </Container> */}
        </MantineProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
